import axios from "axios";
import React, { useEffect, useState } from "react";
import { api } from "../utils/Api";
import {
	Typography,
	Flex,
	Row,
	Col,
	DatePicker,
	Select,
	Statistic,
	Table,
} from "antd";
import { CustomSpinner } from "../utils/CustomComponents";
import dayjs from "dayjs";

const { Text } = Typography;

const FranchiseMaterials = ({ franchise }) => {
	const [loading, setLoading] = useState(true);
	const [loadingTable, setLoadingTable] = useState(true);
	const [date, setDate] = useState(dayjs());
	const [plant, setPlant] = useState(
		localStorage.getItem("plant") || "61985b6a86825f39cc4aba38"
	);
	const [jobList, setJobList] = useState([]);
	const [optionsPlant, setOptionsPlant] = useState([]);
	const [disabled, setDisabled] = useState(true);

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "Material",
			dataIndex: "material",
			key: "material",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Now",
			dataIndex: "now",
			key: "now",
			render: (value) => {
				return (
					<Statistic
						value={value}
						precision={2}
						valueStyle={{
							fontSize: 14,
						}}
					/>
				);
			},
		},
		{
			title: "Today",
			dataIndex: "today",
			key: "today",
			render: (value) => {
				return (
					<Statistic
						value={value}
						precision={2}
						valueStyle={{
							fontSize: 14,
						}}
					/>
				);
			},
		},
		{
			title: "Franchise",
			dataIndex: "franchise",
			key: "franchise",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
	];

	useEffect(() => {
		getJobs(date, plant);
	}, [date, plant]);

	useEffect(() => {
		getPlants();
	}, []);

	const getPlants = async () => {
		const url = api + "/plant/list/57Concrete";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			let list = [];
			data.payload.map((item) => {
				list.push({
					value: item._id,
					label: item.name,
				});
			});
			setOptionsPlant(list);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const getJobs = async (date, plant) => {
		try {
			setLoading(true);
			setDisabled(true);

			const formattedDate = dayjs(date);
			const today = `${formattedDate.year()}-${
				formattedDate.month() + 1
			}-${formattedDate.date()}`;
			const url = api + `/jobpsi/${franchise}?date=${today}&plant=${plant}`;

			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			let { data } = await axios.get(url);

			let obj = {};

			data.map((item) => {
				if (item.aggregates !== null) {
					item.aggregates.cogs.map((cog) => {
						if (
							!obj[
								`${cog.cog.material}_${
									item.franchise === "57Concrete" ||
									item.franchise === null ||
									item.franchise === undefined
										? "57Concrete"
										: item.franchise
								}`
							]
						) {
							obj[
								`${cog.cog.material}_${
									item.franchise === "57Concrete" ||
									item.franchise === null ||
									item.franchise === undefined
										? "57Concrete"
										: item.franchise
								}`
							] = {
								today: cog.quantity * item.loadYD3,
								now: dayjs(item.scheduledDate).isBefore(formattedDate)
									? cog.quantity * item.loadYD3
									: 0,
							};
						} else {
							obj[
								`${cog.cog.material}_${
									item.franchise === "57Concrete" ||
									item.franchise === null ||
									item.franchise === undefined
										? "57Concrete"
										: item.franchise
								}`
							].today += cog.quantity * item.loadYD3;
							obj[
								`${cog.cog.material}_${
									item.franchise === "57Concrete" ||
									item.franchise === null ||
									item.franchise === undefined
										? "57Concrete"
										: item.franchise
								}`
							].now += dayjs(item.scheduledDate).isBefore(formattedDate)
								? cog.quantity * item.loadYD3
								: 0;
						}
					});
				}
			});

			let list = Object.entries(obj).map(([key, value]) => {
				const keyPair = key.split("_");
				return {
					material: keyPair[0],
					franchise: keyPair[1],
					now: value.now,
					today: value.today,
				};
			});

			list = list.filter((i) => i.franchise === franchise);

			setJobList(list);
			setLoading(false);
			setDisabled(false);
			setLoadingTable(false);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const onChangeDate = (value) => {
		setDisabled(true);
		setDate(value);
	};

	const onChangePlant = (value) => {
		setDisabled(true);
		setPlant(value);
	};

	const RenderHeader = () => {
		return (
			<Row gutter={16}>
				<Col span={6}>
					<DatePicker
						size="large"
						onChange={onChangeDate}
						value={date}
						allowClear={false}
						format={"MM/DD/YYYY"}
						style={{ width: "100%" }}
						disabled={disabled}
					/>
				</Col>
				<Col span={6}>
					<Select
						size="large"
						options={optionsPlant}
						value={optionsPlant.filter((o) => {
							return o.value === plant;
						})}
						onChange={onChangePlant}
						style={{ width: "100%" }}
						loading={disabled}
						disabled={disabled}
					/>
				</Col>
			</Row>
		);
	};

	const RenderTable = () => {
		return (
			<Flex gap={"middle"} vertical>
				<Table
					columns={columns}
					dataSource={jobList}
					loading={loadingTable}
					pagination={false}
				/>
			</Flex>
		);
	};

	return (
		<Flex vertical gap={"large"}>
			<RenderHeader />
			{loading ? <CustomSpinner /> : <RenderTable />}
		</Flex>
	);
};

export default FranchiseMaterials;
